import { Cart } from "@insite/client-framework/Services/CartService";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

export interface DbvItemInfo {
    productNumber: string;
    qtyOnHand: number;
}

export const dvbCartline = (cart: Cart | undefined) => {
    if (!cart) return false;
    const dbv = cart?.cartLines?.filter(item => {
        if (
            item.properties.dbv &&
            item.properties.dbv.toLowerCase().includes("dbv") &&
            item.qtyOrdered &&
            item.qtyOnHand < item.qtyOrdered
        ) {
            return item;
        }
    });
    return !!dbv?.length;
};

export const cartlineDvb = (cartline: CartLineModel) => {
     if (
            cartline.properties.dbv &&
            cartline.properties.dbv.toLowerCase().includes("dbv")
        ) {
            return true;
        }

        return false;
}

export const dbvOutOfStockProduct = (cart: Cart | undefined): string[] => {
    if (!cart || !cart.cartLines) return [];

    return cart.cartLines
       // Filter items where the 'dbv' property includes 'dbv' and quantity on hand is 0
        .filter(item =>
            item.properties.dbv?.toLowerCase().includes("dbv") &&
            item.qtyOnHand === 0
        )
          // Return the product name (or empty string if undefined)
        .map(item => item.productName || "")
        .filter(Boolean); // filter out null/undefined
};

export const getDbvProductNumbersExceedingQty = (cart: Cart | undefined): DbvItemInfo[] => {
    if (!cart || !cart.cartLines) return [];

    return cart.cartLines
        
        .filter(item =>
            // Filter DBV items where ordered quantity is greater than available stock
            item.properties.dbv?.toLowerCase().includes("dbv") &&
            item.qtyOrdered != null &&
            item.qtyOnHand != null &&
            item.qtyOrdered > item.qtyOnHand && item.qtyOnHand > 0
        )
           // Map to an object containing productNumber and qtyOnHand
        .map(item => ({
            productNumber: item.productName || "",
            qtyOnHand: item.qtyOnHand!,
        }));
};



